// extracted by mini-css-extract-plugin
export default {"subTitle":"RA_qz2zrA_1OCnYjtDy0","container":"S_l8La5IjLVfUdyMe1Gz","blockTitle":"wbMTDBEKlh4NpYWgVSqK","pulse":"HROKtNkYiiw5FzM17SEU"};